<template>
    <div :class="alertClass" class="alert">
        <div>
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12 6.19995C12.4418 6.19995 12.8 6.55812 12.8 6.99995V13C12.8 13.4418 12.4418 13.8 12 13.8C11.5581 13.8 11.2 13.4418 11.2 13V6.99995C11.2 6.55812 11.5581 6.19995 12 6.19995Z"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M12.5454 16.4045C12.8737 16.7002 12.9001 17.206 12.6043 17.5343L12.5943 17.5454C12.2986 17.8737 11.7928 17.9001 11.4645 17.6043C11.1362 17.3086 11.1098 16.8028 11.4056 16.4745L11.4156 16.4634C11.7113 16.1351 12.2171 16.1087 12.5454 16.4045Z" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.19995 12C1.19995 6.03527 6.03527 1.19995 12 1.19995C17.9646 1.19995 22.7999 6.03527 22.7999 12C22.7999 17.9646 17.9646 22.7999 12 22.7999C6.03527 22.7999 1.19995 17.9646 1.19995 12ZM12 2.79995C6.91893 2.79995 2.79995 6.91893 2.79995 12C2.79995 17.0809 6.91893 21.2 12 21.2C17.0809 21.2 21.2 17.0809 21.2 12C21.2 6.91893 17.0809 2.79995 12 2.79995Z"/>
            </svg>
        </div>
        <p class="label-xl">
            <slot></slot>
        </p>
    </div>
</template>

<style scoped>
.alert {
    border-radius: var(--border-radius-xs);
    border: 1px solid var(--content-1);
    display: flex;
    padding: 12px 16px;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
    align-self: stretch;
}
.alert svg{
    display: block;
}

.alert-error {
    background-color: var(--semantic-danger-light);
    border: 1px solid var(--border-danger);
    color: var(--semantic-danger);
}

.alert-error svg{
    fill: var(--semantic-danger);
    display: block;
}

.alert-info {
    background-color: var(--semantic-info-light);
    border: 1px solid var(--semantic-info);
    color: var(--semantic-info);
}

.alert-info svg{
    fill: var(--semantic-info);
    display: block;
}

.alert-success {
    background-color: var(--semantic-success-light);
    border: 1px solid var(--semantic-success);
    color: var(--semantic-success);
}

.alert-success svg{
    fill: var(--semantic-success);
    display: block;
}

.alert-warning {
    background-color: var(--semantic-warning-light);
    border: 1px solid var(--semantic-warning);
    color: var(--semantic-warning);
}

.alert-warning svg{
    fill: var(--semantic-warning);
    display: block;
}
</style>

<script>
import * as alertVariantConstant from '@/constants/alertVariantConstant';

export default {
    name: 'AlertComponent',
    setup() {
        return {
            alertVariantConstant
        };
    },
    props: {
        variant: {
            type: String,
            default: alertVariantConstant.INFO_ALERT,
            validator: value => [
                alertVariantConstant.INFO_ALERT,
                alertVariantConstant.ERROR_ALERT,
                alertVariantConstant.SUCCESS_ALERT,
                alertVariantConstant.WARNING_ALERT
            ].includes(value)
        }
    },
    computed: {
        alertClass() {
            return {
                'alert-info': alertVariantConstant.INFO_ALERT === this.variant,
                'alert-error': alertVariantConstant.ERROR_ALERT === this.variant,
                'alert-success': alertVariantConstant.SUCCESS_ALERT === this.variant,
                'alert-warning': alertVariantConstant.WARNING_ALERT === this.variant
            };
        }
    }
}
</script>